import { render, staticRenderFns } from "./SPSettings.vue?vue&type=template&id=cc82826a&"
import script from "./SPSettings.vue?vue&type=script&lang=ts&"
export * from "./SPSettings.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports